import { useAskInputSuggestions } from '#pplx/frontend/apps/ask/ask-input/ask-input-attributions/hooks/useAskInputSuggestions.js';
import { renderLazyAskSourceSuggestion } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/components/renderLazyAskSourceSuggestion.js';
import { useAskSourceSuggestionAnalytics } from '#pplx/frontend/apps/ask/ask-input/source-suggestions/analytics/useAskSourceSuggestionAnalytics.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { createSourceSuggestionPlugin } from '#pplx/frontend/composer-sdk-plugins/source-suggestion/sourceSuggestionPlugin.js';
import { useCallback, useMemo } from 'react';
/** Adapts Ask source-suggestion policy and actions into a Composer plugin instance. */
export function useAskSourceSuggestionsPlugin({ onInsertMention, selectedSearchMode, showSources = true, iconOnly = false, }) {
    const handleSourceMentionSelect = useCallback((source, label) => {
        const result = onInsertMention({
            id: source,
            kind: 'source',
            text: label,
            icon: { type: 'source', sourceId: source },
        });
        return result !== 'unavailable';
    }, [onInsertMention]);
    const { sourceSuggestionProps } = useAskInputSuggestions({
        showSources,
        isComputer: selectedSearchMode === SearchMode.ASI,
        onSourceMentionSelect: handleSourceMentionSelect,
    });
    const analytics = useAskSourceSuggestionAnalytics(sourceSuggestionProps.showSourceSuggestions ? sourceSuggestionProps.query : '');
    const renderSuggestion = useCallback((props) => renderLazyAskSourceSuggestion({ ...props, iconOnly }), [iconOnly]);
    const sourceSuggestionsProps = useMemo(() => {
        if (!sourceSuggestionProps.showSourceSuggestions) {
            return undefined;
        }
        return {
            suggestions: sourceSuggestionProps.suggestions,
            onSuggestSource: sourceSuggestionProps.onSuggestSource,
            onConnectSource: sourceSuggestionProps.onConnectSource,
            ...analytics,
            renderSuggestion,
        };
    }, [analytics, sourceSuggestionProps, renderSuggestion]);
    return useMemo(() => sourceSuggestionsProps === undefined
        ? null
        : createSourceSuggestionPlugin({ sourceSuggestionsProps }), [sourceSuggestionsProps]);
}
//# sourceMappingURL=useAskSourceSuggestionsPlugin.js.map